import React from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import { Nav, NavItem, NavLink } from 'reactstrap'
import classnames from 'classnames'
import SearchIcon from "../../static/images/search_icon.svg"
import { FONTS, COLORS } from '../../constants'

export default class Searchbar extends React.Component {
  state={ tempSearch: '' }

  render() {
    return (
      <Wrapper>
        <NavbarTab tabs>
          <NavItem>
            <NavLinkTab
              className={ classnames({ active: get(this.props, 'activeTab') === '1' }) }
              style={ { color: get(this.props, 'activeTab') === '1' ? COLORS.PRIMARY_RED : '',
                borderBottom: get(this.props, 'activeTab') === '1' ? `4px solid ${COLORS.PRIMARY_RED}` : '',
                borderTopStyle: 'none',
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
              } }
              onClick={ () => { get(this.props, 'toggle')('1') } }
            >
            Pending
            </NavLinkTab>
          </NavItem>
          <NavItem>
            <NavLinkTab
              className={ classnames({ active: get(this.props, 'activeTab') === '2' }) }
              style={ { color: get(this.props, 'activeTab') === '2' ? COLORS.PRIMARY_RED : '',
                borderBottom: get(this.props, 'activeTab') === '2' ? `4px solid ${COLORS.PRIMARY_RED}` : '',
                borderTopStyle: 'none',
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
              } }
              onClick={ () => { get(this.props, 'toggle')('2') } }
            >
          All Request
            </NavLinkTab>
          </NavItem>
          <NavItem>
            <SearchField
              placeholder='Search by name'
              onChange={ (e) => {
                if (e.target.value === '') get(this.props, 'handleSearch')(e.target.value)
                this.setState({ tempSearch: e.target.value })
              } }
              onKeyDown={ (e) => {
                if (e.keyCode === 13) get(this.props, 'handleSearch')(this.state.tempSearch)
              } }
            />
          </NavItem>
        </NavbarTab>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom: 10px;
  height: 50px;
`
const SearchField = styled.input`
  height: 30px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 10px;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 20px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  z-index: 999 !important;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const NavbarTab = styled(Nav)`
  height: 100%;
  width: 100%;
  -webkit-box-shadow: 0px 1px 1px #F1F1F1;
  -moz-box-shadow: 0px 1px 1px #F1F1F1;
  box-shadow: 0px 1px 0px #F1F1F1;
  border: none;
  padding-top: 10px;
  @media (max-width: 575.98px) {
      margin-right: 1%;
    }
    @media (max-width: 767.98px) {
      margin-right: 1%;
    }
    @media (max-width: 991.98px) {
      margin-right: 1%;
    }
    .nav-link {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
`
const NavLinkTab = styled(NavLink)`
  height: 40px;
  padding-bottom: 20px;
  cursor: pointer;
  &:hover{
    border: none ;
  }
`



// WEBPACK FOOTER //
// ./src/components/searchbar-inbox/index.js